import { SingleDonation as SingleDonationMCB } from '@bgea-js/form-templates';
import styles from "../../../../src/content/buses-for-naples/styles";
import "../../../../src/content/buses-for-naples/naples-buses.scss";
import * as React from 'react';
export default {
  SingleDonationMCB,
  styles,
  React
};